@if (!routerLink) {
  <button
    appButton
    [name]="name"
    [location]="location"
    [analyticsExtra]="analyticsExtra"
    [color]="color"
    spacing="full"
    [hasIcon]="!!icon || !!imageUrl"
    (click)="onClick.emit($event)"
    [height]="height"
    [class.disabled]="disabled"
    [shape]="shape"
    [weight]="weight"
    [spacing]="fullWidth ? 'full' : ''"
    [alignment]="fullWidth ? 'left' : 'center'"
    [class]="buttonClass"
  >
    <ng-container *ngTemplateOutlet="buttonContent"></ng-container>
  </button>
} @else {
  <a
    appButton
    [name]="name"
    [location]="location"
    [analyticsExtra]="analyticsExtra"
    [color]="color"
    spacing="full"
    [hasIcon]="!!icon || !!imageUrl || !!customIcon"
    [routerLink]="routerLink"
    [routerLinkActive]="routerLinkActive ?? ''"
    [routerLinkActiveOptions]="{ exact: true }"
    [height]="height"
    [class.disabled]="disabled"
    [shape]="shape"
    [weight]="weight"
    [spacing]="fullWidth ? 'full' : ''"
    [alignment]="fullWidth ? 'left' : 'center'"
    [class]="buttonClass"
  >
    <ng-container *ngTemplateOutlet="buttonContent"></ng-container>
  </a>
}
<ng-template #buttonContent>
  @if (!!icon) {
    <app-svg [attr.color]="iconColor" src="/assets/icons/{{ icon }}.svg"></app-svg>
  }
  @if (imageUrl) {
    <img [src]="imageUrl" [attr.loading]="imgLoading" alt="" class="{{ imageClass }}" />
  }
  @if (customIcon) {
    <div class="custom-svg" [innerHTML]="sanitization.bypassSecurityTrustHtml(customIcon)"></div>
  }
  <div class="button-content" [class.full-width]="shortcut || fullWidthButtonContent">
    <ng-content></ng-content>
    @if (shortcut) {
      <div class="shortcut" *onlyForScreens="['desktop']">{{ shortcut }}</div>
    }
  </div>
  <ng-content select="[post]"></ng-content>
</ng-template>
